import type { Map, StyleSpecification } from "maplibre-gl";

// Stadia Maps Alidade Smooth Dark — free tier, no API key required for localhost.
// For production, register a free account at https://stadiamaps.com and add your domain.
export const DARK_STYLE_URL = "/alidade_custom.json";

// Fallback: plain OpenStreetMap raster (no key, always free)
export const OSM_RASTER_STYLE: StyleSpecification = {
  version: 8,
  sources: {
    osm: {
      type: "raster",
      tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
      tileSize: 256,
      attribution: "© OpenStreetMap contributors",
    },
  },
  layers: [{ id: "osm-tiles", type: "raster", source: "osm" }],
};

// Hawke's Bay centre
export const HB_CENTER: [number, number] = [176.91, -39.49];
export const HB_ZOOM = 9;

// ── 3D Terrain ────────────────────────────────────────────────────────────────
// AWS Terrain Tiles (Mapzen/Terrarium RGB format) — free, no API key required.
// Attribution: https://github.com/tilezen/joerd/blob/master/docs/attribution.md
// IMPORTANT: encoding must be "terrarium" — the default "mapbox" gives wrong elevations.
const TERRAIN_TILES =
  "https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png";

export function setupTerrain(map: Map): void {
  map.addSource("terrain-dem", {
    type: "raster-dem",
    tiles: [TERRAIN_TILES],
    tileSize: 256,
    maxzoom: 12,
    encoding: "terrarium",
  });
  map.setTerrain({ source: "terrain-dem", exaggeration: 1.5 });

  // Add hillshade layer for visible terrain relief.
  // Insert before the first symbol layer so labels/icons remain on top.
  const firstSymbolId = map.getStyle().layers.find((l) => l.type === "symbol")?.id;
  map.addLayer(
    {
      id: "terrain-hillshade",
      type: "hillshade",
      source: "terrain-dem",
      paint: {
        "hillshade-shadow-color": "#000000",
        "hillshade-highlight-color": "#ffffff",
        "hillshade-illumination-direction": 335,
        "hillshade-exaggeration": 0.45,
      },
    },
    firstSymbolId,
  );
}
